import { ReactComponent as Dots } from 'assets/signup/dots.svg'

const SignUpHeader = ({ title, idx }: { title: string, idx: number }) => {
    return (
        <div className="flex justify-between items-center mb-4.5 mobile:mb-2 h-7.5 mobile:h-5">
            <p className="font-semibold mobile:text-base text-2xl">{title}</p>
            <div className="flex gap-1">
                {
                    Array(4).fill(null).map((_, index) => {
                        const isPast = idx > index + 1;
                        const isCurrent = idx === index + 1;

                        return (
                            <div className="flex items-center gap-1" key={index}>
                                <div
                                    className={`flex items-center justify-center w-7.5 h-7.5 border-1 rounded-full
                                        ${isPast
                                            ? 'bg-[#ECEEF2] text-white border-transparent'
                                            : isCurrent
                                                ? 'bg-primary text-white border-transparent'
                                                : 'bg-transparent text-[#9D9EB7] border-[#9D9EB7]'
                                        }
                                        mobile:w-5 mobile:h-5 mobile:text-xs
                                        `}
                                >
                                    {index + 1}
                                </div>
                                {index !== 3 && (
                                    <Dots fill={`${idx === index + 2 ? '#196BFF' : '#9D9EB7'}`} />
                                )}
                            </div>
                        );
                    })
                }
            </div>
        </div>
    )
}

export default SignUpHeader